import React from "react";
import { Button, Typography, Box } from "@mui/material";

import paymentFormStyles from "./PaymentForm.styles";

function PaymentForm({ handleDialogOpen }) {
 

  return (
    <Box>
      <Typography variant="body1" sx={{ marginBottom: 2 }}>
        У вас есть 30 минут, чтобы завершить оплату. Если времени не хватит, вы можете продлить заказ, но не более двух раз. 
        Нажимая "Создать заявку", вы резервируете адрес — он будет сохранён до тех пор, пока заказ активен. 
        Также, чтобы не потерять доступ к заказу в случае выхода из браузера или смены страницы, обязательно сохраните ссылку.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleDialogOpen}
        sx={(theme) => paymentFormStyles(theme).button}
      >
        Создать заявку
      </Button>

      
    </Box>
  );
}

export default PaymentForm;
